import React, { useEffect, useState } from "react";
import axios from "axios";
import { Users, Flame } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function SocialProof() {
  const [total, setTotal] = useState(1847);
  const [recent, setRecent] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    let live = true;
    axios.get(`${API}/stats`).then((r) => {
      if (!live) return;
      setTotal(r.data.total || 1847);
      setRecent(r.data.recent || []);
    }).catch(() => {});
    return () => { live = false; };
  }, []);

  useEffect(() => {
    if (recent.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % recent.length), 3000);
    return () => clearInterval(t);
  }, [recent.length]);

  const rolling = [
    recent[idx],
    recent[(idx + 1) % Math.max(recent.length, 1)],
    recent[(idx + 2) % Math.max(recent.length, 1)],
    recent[(idx + 3) % Math.max(recent.length, 1)],
  ].filter(Boolean);

  const formatted = new Intl.NumberFormat("es-MX").format(total);

  return (
    <div className="mt-10 max-w-3xl mx-auto" data-testid="social-proof">
      <div className="bg-white border-[3px] border-black shadow-[5px_5px_0_0_#000] p-4 sm:p-5 flex flex-col sm:flex-row items-center gap-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-[#006847] border-[3px] border-black flex items-center justify-center">
            <Users strokeWidth={3} className="w-6 h-6 text-white" />
          </div>
          <div className="text-left">
            <div className="font-anton uppercase text-3xl leading-none">
              <span data-testid="chingones-counter">{formatted}</span>
            </div>
            <div className="font-outfit text-xs uppercase tracking-widest text-black/60 mt-1">
              chingones con su sticker del Tri
            </div>
          </div>
        </div>
        {rolling.length > 0 && (
          <div className="flex-1 flex items-center gap-2 justify-end w-full sm:w-auto">
            <Flame strokeWidth={3} className="w-4 h-4 text-[#CE1126]" />
            <span className="font-anton uppercase text-xs text-black/70 mr-1">En vivo:</span>
            <div className="flex gap-2">
              {rolling.map((item, i) => (
                <div
                  key={`${item.id}-${i}`}
                  className="w-12 h-12 border-[2px] border-black overflow-hidden bg-[#FDFBF7] transition-transform duration-500"
                  style={{ transform: `rotate(${(i % 2 === 0 ? -1 : 1) * 3}deg)` }}
                  title={item.phrase}
                >
                  <img
                    src={`data:image/png;base64,${item.image_base64}`}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
